import { Button, Drawer, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { WrapperCard, WrapperTabNav } from "./styled";
import React from "react";
import { useProducts } from "../../products";
import { useNavigate } from "react-router-dom";
import { TableProduct2x1 } from "./TableProduct2x1";
import { Product2x1Form } from "./form/Product2x1Form";
const { Text } = Typography;

export const Product2x1 = () => {
  const {
    querySelectorTransform,
  } = useProducts();
  const [openModalCreateProductToGift, setOpenModalCreateProductToGift] = React.useState<boolean>(false)
  const navigate = useNavigate()
  return (
    <AdminMenuLayout pageDescription="Products" title="Products">
      <WrapperCard>
        <div style={{width: '100%'}}>

        <Text style={{color: 'gray', cursor: 'pointer'}} onClick={()=>navigate('/rules-2-x-1-products')}>Ir atras</Text>
        </div>
        <WrapperTabNav
          items={[
            {
              label: `PRODUCTOS QUE SE LISTAN COMO 2x1`,
              key: "3",
              children: (
                <>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    {" "}
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={()=>setOpenModalCreateProductToGift(true)}
                    >
                      Agregar el producto que se va a listar como 2x1
                    </Button>
                  </div>
                  <TableProduct2x1 fetchQuery={querySelectorTransform} />
                </>
              ),
            },
          ]}
        />
         <Drawer
          title={`Agregar el producto que se va a listar como 2x1`}
          open={openModalCreateProductToGift}
          width={"320px"}
          destroyOnClose
          onClose={() => setOpenModalCreateProductToGift(false)}
        >
          <Product2x1Form setOpenModalCreate={setOpenModalCreateProductToGift} />
        </Drawer>
      </WrapperCard>
    </AdminMenuLayout>
  );
};
